import {ReactElement, useState} from 'react'
import {startOfMonth} from 'date-fns'
import {Trans} from 'react-i18next'
import {Grid} from '@material-ui/core'
import Loading from '../../../../Common/Loading'
import NotificationBar from '../../../../Common/NotificationBar'
import messages from '../../../../../assets/messages'
import {useProvider} from '../../hooks/useProvider'
import {usePagination} from '../../../../../shared/hooks/usePagination'
import {DateSelect} from './components/DateSelect'
import {MonthlyStatistics} from './components/MonthlyStatistics'
import {TotalStatistics} from './components/TotalStatistics'
import {SubscriptionsTable} from './components/SubscriptionsTable'
import {useStyles} from './styles'

type Account = {
  id: number
}

type BrokereeProviderStatsProps = {
  account: Account
}

export const BrokereeProviderStats = (props: BrokereeProviderStatsProps): ReactElement => {
  const {account} = props

  const classes = useStyles()
  const defaultDate = startOfMonth(new Date()).toISOString()
  const [selectedDate, setSelectedDate] = useState(defaultDate)
  const {loading, provider} = useProvider(account.id)
  const paginationApi = usePagination({limit: 10})

  const amountClassNames = {
    currency: classes.amountCurrency,
    value: classes.amountValue,
    fraction: classes.amountFraction
  }

  const handleDateChange = (nextValue: string): void => {
    setSelectedDate(nextValue)
    paginationApi.reset()
  }

  if (loading) return <Loading />
  if (provider == null) return (
    <Grid>
      <NotificationBar status="error">
        <Trans {...messages.generalError} />
      </NotificationBar>
    </Grid>
  )

  return (
    <Grid container spacing={2}>
      <DateSelect
        value={selectedDate}
        provider={provider}
        onChange={handleDateChange}
      />
      <MonthlyStatistics
        accountId={account.id}
        selectedDate={selectedDate}
        amountClassNames={amountClassNames}
      />
      <SubscriptionsTable
        accountId={account.id}
        selectedDate={selectedDate}
        paginationApi={paginationApi}
        isDefaultDate={selectedDate === defaultDate}
       />
      <TotalStatistics
        accountId={account.id}
        amountClassNames={amountClassNames}
      />
    </Grid>
  )
}
